import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { AudioRecordingService } from 'src/app/Service/audio-recording.service';
import axios from 'src/app/Service/axios';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({
  selector: 'app-offline-vehicles',
  templateUrl: './offline-vehicles.component.html',
  styleUrls: ['./offline-vehicles.component.css'],
})
export class OfflineVehiclesComponent implements OnInit {
  bSendPush: boolean = false;
  isAudioRecording: boolean = false;
  bSelectAll = false;
  loading = false;
  hasError = false;
  filtersOpen = false;
  searchText = '';
  currentPage = 1;
  pageSize = 20;
  selectedCount = 0;
  pagedRows: any[] = [];
  bSendPayamak: boolean = false;
  audioRecordedTime: any;
  audioBlobUrl: any = '';
  audioSrcUrl: any = '';
  audioBlob: any;
  audioName: any;
  lst_Expired: any = [];
  lst_Search: any = [];
  @Input() isCalled: boolean = false;
  mdl_Request: FormGroup = this._formBuilder.group({
    strSession: new FormControl(
      this._gurd.decrypt(localStorage.getItem('Session')!),
    ),

    iSystemUser: new FormControl(
      this._gurd.decrypt(localStorage.getItem('ID')!),
    ),

    lststrUnitIDs: new FormControl('', Validators.required),

    strTitle: new FormControl('', Validators.required),

    strMessage: new FormControl(''),

    strVoice: new FormControl(''),

    iPushType: new FormControl(''),

    bSMS: new FormControl(false),

    strDate: new FormControl(
      moment().subtract(1, 'day').format('jYYYY/jMM/jDD'),
    ),

    tiType: new FormControl('4'),
  });

  constructor(
    private _tooltip: NotificationService,

    private _formBuilder: FormBuilder,

    private _gurd: GurdServiceService,

    public _other: OtherService,

    private _router: Router,

    public gurdService: GurdServiceService,

    private audioRecordingService: AudioRecordingService,

    private sanitizer: DomSanitizer,

    private ref: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.fetchOfflineCars();

    var data = window.localStorage.getItem('menu') as any;

    this.bSendPush = JSON.parse(
      this.gurdService.decrypt(data),
    ).bSendPush2MobilesUser;

    this.bSendPayamak = JSON.parse(
      this.gurdService.decrypt(data),
    ).bSendSMS2Driver;

    this.audioRecordingService.getRecordedBlob().subscribe((data) => {
      var base64 = this.blobToBase64(data.blob);

      base64.then((result: any) => {
        result = result.replace('data:audio/wav;base64,', '');

        this.mdl_Request.get('strVoice')?.setValue(result);
      });

      this.audioBlob = data.blob;

      this.audioName = data.title;

      this.audioBlobUrl = this.sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(data.blob),
      );

      this.ref.detectChanges();
    });

    this.audioRecordingService.recordingFailed().subscribe(() => {
      this.isAudioRecording = false;

      this.ref.detectChanges();
    });

    this.audioRecordingService.getRecordedTime().subscribe((time) => {
      this.audioRecordedTime = time;

      if (time == '00:21') {
        this.stopAudioRecording();

        this._tooltip.showError('حده اکثر زمان ضبط صدا 20 ثانیه است');
      }

      this.ref.detectChanges();
    });
  }

  fetchOfflineCars = async () => {
    if (this.loading) return;
    this.loading = true;
    this.hasError = false;
    this.lst_Search = [];
    this.refreshTable(true);
    try {
      const response = await axios.post('Mobiles_Off_List',
        this._other.stringNumberToNumber(this.mdl_Request.value));
      const result = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
      if (!Array.isArray(result)) {
        if (result?.iResult == 0) this._tooltip.showError(result.strError);
        throw new Error('Invalid vehicle list');
      }
      this.lst_Search = result;
      this.refreshTable(true);
    } catch {
      this.hasError = true;
    } finally {
      this.loading = false;
    }
  }

  refreshTable(resetPage = false): void {
    const query = this.searchText.trim();
    this.lst_Expired = this.lst_Search.filter((row: any) =>
      ['strFullName', 'strVehicleNo', 'strMobile', 'strCellNo', 'strDateTime', 'strValidDate', 'strMobileDomain_strComment']
        .some(key => String(row[key] ?? '').includes(query)));
    if (resetPage) this.currentPage = 1;
    this.currentPage = Math.min(this.currentPage, Math.max(1, Math.ceil(this.lst_Expired.length / this.pageSize)));
    const start = (this.currentPage - 1) * this.pageSize;
    this.pagedRows = this.lst_Expired.slice(start, start + this.pageSize);
    this.updateSelection();
  }

  changePage(page: number): void {
    this.currentPage = page;
    this.refreshTable();
  }

  changePageSize(size: number): void {
    this.pageSize = size;
    this.refreshTable(true);
  }

  trackByVehicle(_index: number, row: any): string {
    return row.strUnitID;
  }

  toggleAll(checked: boolean): void {
    this.lst_Expired.forEach((row: any) => row.bChosen = checked);
    this.updateSelection();
  }

  toggleVehicle(row: any, checked: boolean): void {
    row.bChosen = checked;
    this.updateSelection();
  }

  private updateSelection(): void {
    this.selectedCount = this.lst_Expired.filter((row: any) => row.bChosen).length;
    this.bSelectAll = this.lst_Expired.length > 0 && this.selectedCount === this.lst_Expired.length;
  }

  openPush_User(): void {
    if (this.loading || !this.bSendPush) return;
    const ids = this.lst_Expired.filter((row: any) => row.bChosen).map((row: any) => row.strUnitID);
    if (!ids.length) return this._tooltip.showError('لیست انتخابی شما خالی می باشد');
    this.mdl_Request.patchValue({ lststrUnitIDs: ids, iPushType: 0 });
    $('#Push_Modal').modal('show');
  }

  changeRoute(item: any) {

    let URL = `/carInfo/${item.strUnitID}`;

    window.open(URL, '_blank')

  }

  exportexcel(): void {
    const rows = this.lst_Expired.map((row: any, index: number) => ({
      'ردیف': index + 1,
      'نام ردیاب': row.strFullName,
      'پلاک': row.strVehicleNo,
      'شماره راننده': row.strMobile,
      'شماره سیم‌کارت': row.strCellNo,
      'آخرین لاگ': row.strDateTime,
      'تاریخ پایان اعتبار': row.strValidDate,
      'حوزه خدمت': row.strMobileDomain_strComment,
    }));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(rows), 'Sheet1');
    XLSX.writeFile(workbook, 'ردیاب‌های قطع.xlsx');
  }

  ///AudioHandler
  startAudioRecording() {
    navigator.mediaDevices
      .getUserMedia({ audio: true })

      .then((stream) => {
        if (!this.isAudioRecording) {
          this.isAudioRecording = true;

          this.audioRecordingService.startRecording();
        }
      })
      .catch((err) => {
        if (err.message == 'Requested device not found') {
          this._tooltip.showError('سیستم شما دارای میکروفون نمی باشد');
        } else {
          alert('خطا در ضبظ صدا');
        }
      });
  }

  abortAudioRecording() {
    if (this.isAudioRecording) {
      this.isAudioRecording = false;

      this.audioRecordingService.abortRecording();
    }
  }

  clearAudioRecordedData() {
    this.mdl_Request.get('strVoice')?.setValue('');

    this.audioBlobUrl = null;

    this.audioSrcUrl = '';

    this._tooltip.showSuccess('صدا با موفقیت حذف شد');
  }

  stopAudioRecording() {
    if (this.isAudioRecording) {
      this.audioRecordingService.stopRecording();

      this.isAudioRecording = false;

      this.mdl_Request.get('strMessage')?.setValue('');

      this.mdl_Request.get('tiType')?.setValue('4');

      this.playAudio();
    }
  }

  blobToBase64(blob: any) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();

      reader.onloadend = () => resolve(reader.result);

      reader.readAsDataURL(blob);
    });
  }

  isAudioRecorded(): boolean {
    return this.mdl_Request.get('strVoice')?.value != '' ? true : false;
  }

  playAudio() {
    setTimeout(() => {
      this.audioSrcUrl = this.sanitizer.bypassSecurityTrustUrl(
        `data:audio/mp3;base64,` + this.mdl_Request.get('strVoice')?.value,
      );
    }, 200);
  }

  sendPush_4Users = async () => {
    if (this.mdl_Request.invalid)
      return this._tooltip.showError('عنوان را وارد کنید');

    if (
      this.mdl_Request.get('iPushType')?.value == 1 &&
      this.mdl_Request.get('strMessage')?.value.trim() == ''
    )
      return this._tooltip.showError('متن پیام را وارد کنید');

    if (
      this.mdl_Request.get('iPushType')?.value == 2 &&
      this.mdl_Request.get('strVoice')?.value == ''
    )
      return this._tooltip.showError('صدا را ضبط کنید');
    else {
      if (this.mdl_Request.get('iPushType')?.value == 2) {
        this.mdl_Request.get('strMessage')?.setValue('');

        this.mdl_Request.get('tiType')?.setValue('4');
      }

      if (this.mdl_Request.get('iPushType')?.value == 1) {
        this.mdl_Request.get('strVoice')?.setValue('');

        this.mdl_Request.get('tiType')?.setValue('0');
      }

      this._other.Showspinner();

      var model = this._other.stringNumberToNumber(this.mdl_Request.value);

      let response = await axios.post(`SendPush2MobilesSelected`, model);

      this._other.nonespinner();

      let res = JSON.parse(response.data.toString());

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this._tooltip.showSuccess('پیام با موفقیت ارسال شد');

      this.mdl_Request.patchValue({
        lststrUnitIDs: '',

        strTitle: '',

        strMessage: '',

        strVoice: '',
      });

      $('#Push_Modal').modal('hide');
    }
  };
}
